/* eslint-disable @typescript-eslint/no-explicit-any */

export const getImageArticle = (data: any, id: string) => {
  return data?.includes?.Asset?.find((item: any) => item?.sys?.id == id)
}
